// extracted by mini-css-extract-plugin
export default {"container":"_2VJVG","title":"_3kqW0"};